// async function fetchUserLocation() {
//   try {
//     const response = await fetch("https://ipinfo.io/json?token=****");
//     if (!response.ok) {
//       throw new Error("Failed to fetch user location");
//     }
//     const data = await response.json();

//     if (data && data.country) {
//       localStorage.setItem("userCountry", data.country);
//       console.log("User country saved to localStorage:", data.country);

//       applyCountryRules(data.country);
//     }

//     return data;
//   } catch (error) {
//     console.error("Error fetching user location:", error);
//     return null;
//   }
// }

// // Apply rules based only on country
// function applyCountryRules(country) {
//   if (country === "US") {
//     hideElementsForUS();
//     showBottleNexus(); // always show for US visitors
//   } else {
//     hideBottleNexus(); // always hide for non-US visitors
//   }
// }

// Detect US market by URL path — no IP lookup needed
if (!window.customElements.get("checkout-consent")) {
  window.customElements.define(
    "checkout-consent",
    class CheckoutConsent extends HTMLElement {
      connectedCallback() {
        const checkbox = this.querySelector('input[type="checkbox"]');
        const checkoutButton = this.querySelector('[name="checkout"]');

        if (!checkbox || !checkoutButton) {
          return;
        }

        const updateCheckoutButton = () => {
          checkoutButton.setAttribute("aria-disabled", String(!checkbox.checked));

          if (checkbox.checked) {
            checkbox.removeAttribute("aria-invalid");
            this.querySelector('[role="alert"]')?.setAttribute("hidden", "");
          }
        };

        checkbox.addEventListener("change", updateCheckoutButton);
        updateCheckoutButton();
      }

      showValidationError() {
        const checkbox = this.querySelector('input[type="checkbox"]');

        checkbox?.setAttribute("aria-invalid", "true");
        this.querySelector('[role="alert"]')?.removeAttribute("hidden");
        checkbox?.focus();
      }
    }
  );
}

document.addEventListener(
  "click",
  (event) => {
    const checkoutButton = event.target.closest?.('checkout-consent [name="checkout"]');

    if (!checkoutButton) {
      return;
    }

    const consent = checkoutButton.closest("checkout-consent");
    const checkbox = consent?.querySelector('input[type="checkbox"]');

    if (checkbox?.checked) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    consent?.showValidationError();
  },
  true
);

function isUSMarket() {
  const path = window.location.pathname;
  return path.startsWith('/en-us') || path.startsWith('/fr-us');
}

// Apply rules based on URL path
function applyCountryRules() {
  if (isUSMarket()) {
    hideElementsForUS();
    showBottleNexus();
  } else {
    hideBottleNexus();
  }
}


// Function to hide multiple elements by selector (via injected CSS)
function hideElementsForUS() {
  const selectors = [
    // ".price-list",
    // ".price-list.price-list--product",
    ".product-card__quick-add-button",
    ".header__account-link.sm-max\\:hidden",
    ".relative.header__cart-link",
    ".v-stack.gap-4",
    ".line-item-property",
    ".v-stack.gap-1.justify-items-start",
    ".product-sticky-bar.is-visible",
    ".slp_fcec57.slp_4f77b0",
    // "#product-list-template--25965713031508__main > product-card:nth-child(2)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(6)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(8)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(9)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(10)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(11)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(12)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(13)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(14)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(15)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(16)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(17)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(18)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(19)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(20)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(21)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(22)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(23)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(24)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(25)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(26)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(27)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(28)",
    // "#product-list-template--25965713031508__main > product-card:nth-child(29)"
  ];

  const css = selectors
    .map((selector) => `${selector} { display: none !important; }`)
    .join("\n");

  if (!document.getElementById("hide-us-elements-style")) {
    const style = document.createElement("style");
    style.id = "hide-us-elements-style";
    style.textContent = css;
    document.head.appendChild(style);
  }

  console.log("Elements hidden for US visitors (via CSS)");

  observeDynamicElements(selectors);
}

// Function to show .bottlenexus
function showBottleNexus() {
  const css = `.bottlenexus { display: block !important; visibility: visible !important; opacity: 1 !important; }`;

  if (!document.getElementById("show-bottlenexus-style")) {
    const style = document.createElement("style");
    style.id = "show-bottlenexus-style";
    style.textContent = css;
    document.head.appendChild(style);
  }

  console.log("BottleNexus is visible for US visitors");

  observeBottleNexus(true);
}

// Function to hide .bottlenexus
function hideBottleNexus() {
  const css = `.bottlenexus { display: none !important; }`;

  if (!document.getElementById("hide-bottlenexus-style")) {
    const style = document.createElement("style");
    style.id = "hide-bottlenexus-style";
    style.textContent = css;
    document.head.appendChild(style);
  }

  console.log("BottleNexus hidden for non-US visitors");

  observeBottleNexus(false);
}

// Helper : attend que document.body existe avant de lancer le callback
function whenBodyReady(callback) {
  if (document.body) {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback, { once: true });
  }
}

// MutationObserver for hidden elements
function observeDynamicElements(selectors) {
  whenBodyReady(() => {
    const observer = new MutationObserver(() => {
      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          el.style.display = "none";
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

// MutationObserver for .bottlenexus
function observeBottleNexus(show) {
  whenBodyReady(() => {
    const observer = new MutationObserver(() => {
      document.querySelectorAll(".bottlenexus").forEach((el) => {
        el.style.display = show ? "block" : "none";
        el.style.visibility = show ? "visible" : "hidden";
        el.style.opacity = show ? "1" : "0";
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

// // Run only once per user (check localStorage)
// (function initUserLocation() {
//   const savedCountry = localStorage.getItem("userCountry");

//   if (savedCountry) {
//     console.log("User country already in localStorage:", savedCountry);
//     applyCountryRules(savedCountry);
//   } else {
//     fetchUserLocation();
//   }
// })();

(function initUserLocation() {
  applyCountryRules();
})();

(function initAutoGifts() {
  /*
   * Cadeaux automatiques (blocs "Cadeau automatique" du panier lateral).
   * Chaque bloc : produit offert, produits/collections declencheurs, exclusions, montant minimum,
   * exclusion de la vente au personnel et code promo qui rend le cadeau gratuit.
   * Le site ajoute le cadeau (quantite 1, propriete _auto_gwp = id du bloc) et applique le code quand les regles
   * sont remplies ; il retire les deux sinon. Les codes saisis par le client sont conserves.
   */
  const GIFT_PROPERTY = "_auto_gwp";
  const MAX_STEPS = 8;
  const cartBaseUrl = window.Shopify?.routes?.root || "/";

  const readConfig = () => {
    const element = document.getElementById("auto-gifts-config");
    if (!element) return null;
    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error("[AutoGift] configuration illisible", error);
      return null;
    }
  };

  /* Decision pure (testable) : renvoie les lignes a retirer, les cadeaux a ajouter et les codes a appliquer */
  const computeGiftPlan = (config, items, currentCodes) => {
    const rules = (config.rules || []).filter((rule) => rule.variantId);
    const ruleIds = new Set(rules.map((rule) => rule.id));
    const ruleCodes = new Set(rules.map((rule) => (rule.code || "").toUpperCase()).filter(Boolean));
    const removeKeys = [];
    const setQuantity = [];
    const add = [];
    const wantedCodes = [];

    /* Lignes cadeau orphelines (ancien marqueur ou bloc supprime) */
    items.forEach((item) => {
      const marker = item.gift;
      if (marker && !ruleIds.has(marker)) removeKeys.push(item.key);
    });

    rules.forEach((rule) => {
      const giftLines = items.filter((item) => item.gift === rule.id);
      const includeProducts = rule.includeProducts || [];
      const includeCollections = rule.includeCollections || [];
      const excludeProducts = rule.excludeProducts || [];
      const excludeCollections = rule.excludeCollections || [];
      const includeAll = includeProducts.length === 0 && includeCollections.length === 0;

      const eligible = items.filter((item) => {
        if (item.gift || item.service) return false;
        const collections = item.collections || [];
        const included = includeAll || includeProducts.includes(item.product_id) || collections.some((id) => includeCollections.includes(id));
        const excluded = excludeProducts.includes(item.product_id) || collections.some((id) => excludeCollections.includes(id));
        return included && !excluded;
      });

      const eligibleCents = eligible.reduce((sum, item) => sum + item.line_price, 0);
      const shouldHave =
        rule.enabled !== false &&
        !(rule.excludeStaff && config.isStaff) &&
        eligible.length > 0 &&
        eligibleCents >= (rule.minCents || 0);

      if (!shouldHave) {
        giftLines.forEach((line) => removeKeys.push(line.key));
        return;
      }

      const [first, ...extra] = giftLines;
      extra.forEach((line) => removeKeys.push(line.key));
      if (!first) add.push({ id: rule.variantId, quantity: 1, properties: { [GIFT_PROPERTY]: rule.id } });
      else if (first.quantity !== 1) setQuantity.push({ key: first.key, quantity: 1 });
      if (rule.code) wantedCodes.push(rule.code.toUpperCase());
    });

    /* Codes : on garde ceux du client, on ajoute/retire seulement les codes des cadeaux */
    const keptCodes = currentCodes.filter((code) => !ruleCodes.has(code.toUpperCase()));
    const codes = [...new Set([...keptCodes, ...wantedCodes])];
    const sameCodes =
      codes.length === currentCodes.length && codes.every((code) => currentCodes.map((c) => c.toUpperCase()).includes(code.toUpperCase()));

    return { removeKeys: [...new Set(removeKeys)], setQuantity, add, codes, codesChanged: !sameCodes };
  };

  window.CamusAutoGift = { computeGiftPlan };

  const post = (path, body) =>
    fetch(`${cartBaseUrl}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then((response) => {
      if (!response.ok) throw new Error(`[AutoGift] ${path} ${response.status}`);
      return response.json();
    });

  /* Pas d'en-tete Accept JSON ici : avec lui, Shopify renvoie cart.js au lieu du template gift-data */
  const fetchGiftData = async () => {
    const [dataResponse, cartResponse] = await Promise.all([
      fetch(`${cartBaseUrl}cart?view=gift-data`, { credentials: "same-origin", cache: "no-store" }),
      fetch(`${cartBaseUrl}cart.js`, { headers: { Accept: "application/json" }, cache: "no-store" }),
    ]);
    const data = JSON.parse(await dataResponse.text());
    const cart = await cartResponse.json();
    const items = data.items;
    if (!Array.isArray(items) || items.some((item) => !("gift" in item) || !("collections" in item))) {
      throw new Error("[AutoGift] donnees panier inattendues, aucune modification");
    }
    const codes = (cart.discount_codes || []).map((discount) => discount.code);
    return { items, codes };
  };

  /*
   * Applique le plan une modification a la fois : Shopify change la cle d'une ligne quand une remise s'y applique,
   * donc on relit le panier apres chaque modification. Retourne true si le panier a change.
   */
  const syncOnce = async () => {
    const config = readConfig();
    if (!config) return false;

    for (let step = 0; step < MAX_STEPS; step++) {
      const { items, codes } = await fetchGiftData();
      const plan = computeGiftPlan(config, items, codes);

      if (plan.removeKeys.length > 0) await post("cart/change.js", { id: plan.removeKeys[0], quantity: 0 });
      else if (plan.setQuantity.length > 0) await post("cart/change.js", { id: plan.setQuantity[0].key, quantity: 1 });
      else if (plan.add.length > 0) await post("cart/add.js", { items: [plan.add[0]] });
      else if (plan.codesChanged) await post("cart/update.js", { discount: plan.codes.join(",") });
      else return step > 0;
    }
    /* Securite anti-boucle : on s'arrete sans recharger la page */
    console.warn("[AutoGift] synchronisation interrompue (trop d'etapes)");
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    return false;
  };

  /* Une seule synchronisation a la fois, y compris entre plusieurs onglets ouverts */
  let current = null;
  let queued = false;

  const withCrossTabLock = (task) =>
    navigator.locks?.request ? navigator.locks.request("camus-auto-gifts", task) : task();

  const sync = () => {
    if (current) {
      queued = true;
      return current;
    }
    current = withCrossTabLock(syncOnce)
      .catch((error) => {
        console.error("[AutoGift] synchronisation", error);
        return false;
      })
      .finally(() => {
        current = null;
      });
    return current;
  };

  const isCartPage = () =>
    window.themeVariables?.settings?.pageType === "cart" || /\/cart(\/|$|\?)/.test(window.location.pathname);

  const runSync = async () => {
    const changed = await sync();
    if (queued && !current) {
      queued = false;
      setTimeout(runSync, 0);
      return;
    }
    if (!changed) return;
    if (isCartPage()) {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  };

  /* Garde-fou avant le paiement : on resynchronise, puis on laisse partir vers le checkout */
  let checkoutValidated = false;

  const checkoutTrigger = (element) => {
    if (!element || !element.closest) return null;
    const submit = element.closest('[name="checkout"]');
    if (submit) return { type: "submit", node: submit };
    const link = element.closest('a[href*="/checkout"]');
    if (link) return { type: "link", node: link };
    return null;
  };

  document.addEventListener(
    "click",
    (event) => {
      if (checkoutValidated || !readConfig()) return;
      const trigger = checkoutTrigger(event.target);
      if (!trigger || trigger.node.getAttribute("aria-disabled") === "true") return;

      event.preventDefault();
      event.stopImmediatePropagation();

      sync().finally(() => {
        checkoutValidated = true;
        if (trigger.type === "link") {
          window.location.href = trigger.node.getAttribute("href");
          return;
        }
        const form = trigger.node.form || trigger.node.closest("form");
        if (form && typeof form.requestSubmit === "function") form.requestSubmit(trigger.node);
        else if (form) form.submit();
        else trigger.node.click();
      });
    },
    true
  );

  const boot = () => {
    if (!readConfig()) return;
    runSync();
    document.addEventListener("cart:change", () => setTimeout(runSync, 0));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();